




















import Vue from 'vue'
import { oneOf } from '@/utils/helper'
export default Vue.extend({
  props: {
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    linear: {
      type: Boolean,
      default: false
    },
    labelBold: {
      type: Boolean,
      default: false
    },
    labelSize: {
      type: String,
      default: 'md',
      validator: oneOf(['sm', 'md', 'lg'])
    },
    wrap: {
      type: Boolean,
      default: false
    }
  }
})
